import {
    NOT_AVAILABLE_CELL_BACKGROUND,
    StyledRecommendationCell,
} from '@/components/decisionSupport/tables/RecommendationsTable.styled';
import { FC } from 'react';

type NotAvailableCellProps = {
    label?: string;
};

export const NotAvailableCell: FC<NotAvailableCellProps> = ({ label = 'N/A' }) => (
    <StyledRecommendationCell backgroundColor={NOT_AVAILABLE_CELL_BACKGROUND}>
        {label}
    </StyledRecommendationCell>
);
